import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "locale-switcher" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "locale-label-long" }
const _hoisted_4 = { class: "locale-label-short" }

import { computed } from 'vue'

import { supportedLocales } from '@/i18n'
import { SupportedLocaleList } from '@/i18n/types'
import { usePreferencesStore } from '@/store/preferences'


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  setup(__props) {

const preferences = usePreferencesStore()

const locales = computed<SupportedLocaleList>(
  (): SupportedLocaleList => supportedLocales,
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, (locale) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `locale-${locale.value}`
      }, [
        _createElementVNode("a", {
          class: "inverted",
          href: "#",
          onClick: _withModifiers(($event: any) => (_unref(preferences).setLocale(locale.value)), ["prevent"])
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(locale.label), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(locale.value), 1)
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})